export class EmptyCognitoClinicIdsError extends Error {
  public constructor() {
    super('Empty cognito clinic ids')
  }
}
